import React from 'react'

import './ActionableDataSlide.scss'

export const ActionableDataSlide = (): React.ReactElement => {
  return (
    <div className="slide-container">
      <div className="consumerImage-4" />
      <h1 className="header-actionable mt-4 mb-2">Actionable data</h1>
      <p className="subheader-consumer-4">
        Insights when you hover over charts help you turn data into decisions.
      </p>
      <p className="text-sm text-inactive productConsumer">gfknewron Consumer</p>
    </div>
  )
}
